import { Component } from '@angular/core';

@Component({
  selector: 'app-email-verification-fail',
  imports: [],
  templateUrl: './email-verification-fail.component.html',
  styleUrl: './email-verification-fail.component.scss'
})
export class EmailVerificationFailComponent {

}
